import { memo } from "react";
import { ListItem, ListItemText } from "@mui/material";
// types
import type { DeviceId, DeviceName } from "../../../types/device";

type Props = Readonly<{
	deviceId: DeviceId;
	deviceName: DeviceName;
	divider: boolean;
}>;

const DisconnectedDevice = ({ deviceId, deviceName, divider }: Props) => (
	<ListItem key={deviceId} divider={divider}>
		<ListItemText
			primary={deviceName}
			secondary={deviceId}
			slotProps={{
				primary: {
					noWrap: true,
				},
			}}
		/>
	</ListItem>
);

export default memo(DisconnectedDevice);
